import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { fontTitle } from 'Styles/fonts';
import { black, blue, white } from 'Styles/colors';
import ButtonIcon from '../Icons/ButtonIcon';

export const TOOLTIP_ARROW_HEIGHT = 11;

export const TooltipHead = styled.div`
  position: relative;

  p {
    ${fontTitle(16)};
    padding: 16px 48px 4px 24px;
    color: ${black};
    margin: 0;
  }
`;

export const TooltipContent = styled.div`
  text-transform: ${({ textTransform }) => textTransform};
  padding: 0 24px;
  font-family: var(--bombas-font), sans-serif;
`;

export const Tooltip = styled.div.attrs(() => ({
  role: 'dialog'
}))`
  ${({ position }) => position}
  z-index: 1010;
  border-radius: 4px;
  box-shadow: 0 0 4px 2px rgba(29, 29, 29, 0.12);
  transition: opacity ${({ transitionDuration }) => transitionDuration}ms linear;
  display: grid;
  /**
  * Safari 10 doesn't support max-content keyword, causing the tooltip layout to break
  * It will see -webkit-max-content and use that
  **/
  grid-template-columns: -webkit-max-content; /* stylelint-disable-line */
  grid-template-columns: minmax(max-content, 1fr);
  background: ${white};

  &.tool-tip-transition-enter {
    opacity: 0;
  }

  &.tool-tip-transition-enter-active,
  &.tool-tip-transition-enter-done {
    opacity: 1;
  }

  &.tool-tip-transition-exit {
    opacity: 1;
  }

  &.tool-tip-transition-exit-done,
  &.tool-tip-transition-exit-active {
    opacity: 0;
  }
`;

export const TooltipInnerContainer = styled.div`
  position: relative;
  background: ${white};
  padding-bottom: 16px;
  border-radius: 4px;
  ${({ action }) => action === 'hover' && 'padding-top: 16px;'};
`;

export const TooltipArrow = styled.div`
  ${ifProp('position', ({ position }) => ({
    ...position,
    transform: `${position.transform} rotate(45deg) skew(15deg, 15deg)`
  }))}

  ${(ifProp('placement'),
  ({ placement }) =>
    placement && placement.includes('top')
      ? `bottom: -${TOOLTIP_ARROW_HEIGHT}px;`
      : `top: -${TOOLTIP_ARROW_HEIGHT}px;`)}

  position: absolute;
  z-index: -1;
  background: ${white};
  width: 30px;
  height: 30px;
  box-shadow: 0 0 4px 2px rgba(29, 29, 29, 0.12);
  border-radius: 4px;
`;

export const ButtonIconWithFocus = styled(ButtonIcon)`
  position: absolute;
  font-size: 20px;
  right: 0;
  top: 0;
  height: 48px;
  width: 48px;

  &:focus {
    outline: ${blue} auto 4px;
    outline-offset: -3px;
  }
`;

Tooltip.defaultProps = {
  position: {}
};

TooltipArrow.defaultProps = {
  rotateArrow: '',
  position: null
};
